import { render, staticRenderFns } from "./ComboMealSizeModifier.vue?vue&type=template&id=bca2fefc&"
import script from "./ComboMealSizeModifier.vue?vue&type=script&lang=js&"
export * from "./ComboMealSizeModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports